import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import SpriteIcon from 'components/ui/SpriteIcon';
import Button from 'components/ui/Button/Button';
import {
  aboutUsConfigFirst,
  aboutUsConfigSecond,
} from 'modules/about/constants';
import womanImg from 'assets/img/about-us-page/woman.png';
import roomsImg from 'assets/img/about-us-page/rooms.png';
import { toggleHowItWorksModalAction } from 'modules/layout/store/actions';
import IconButton from 'components/ui/IconButton/IconButton';
import { Link, useHistory } from 'react-router-dom';
import classes from './About.module.scss';
import { routesByName } from '../../constants/routes';

const bannerBgStyle = {
  backgroundImage: `url(${womanImg})`,
};

const AboutContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const handleModalOpen = useCallback(() => {
    dispatch(toggleHowItWorksModalAction(true));
  }, [dispatch]);

  const handleLinkOpen = (link) => {
    history.push(link);
  };

  return (
    <section className={classes.root}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 className={`${classes.title} font-title text-uppercase`}>
          About Us
        </h1>
        <Button
          onClick={handleModalOpen}
          className={`${classes.btn} d-inline-flex align-items-center `}
          inline
        >
          <SpriteIcon name="play-icon" size="lg" className="mr-1" />
          How &nbsp;<span className="font-semi-bold">It Works</span>
        </Button>
      </div>
      <div className={`${classes.content} background-white`}>
        <div className="row">
          <div className={`${classes.leftColumn} col-7`}>
            <p
              className={`${classes.paragraph} color-gray-6 font-italic pr-5 mb-2 text-sm`}
            >
              Pin the Look is a social curation platform that streamlines the
              process of decorating your home. We understand how time-consuming
              and overwhelming it can be to select a design concept and then
              painstakingly search for items to get the look you love at prices
              you can afford.
            </p>
            <p
              className={`${classes.paragraph} color-gray-6 font-italic pr-5 mb-2 text-sm`}
            >
              With Pin the Look, finding home decor is fast, fun, and easy! You
              can start in the
              <span
                className="cursor-pointer primary-color"
                onClick={() => handleLinkOpen(routesByName.getTheLook.index)}
              >
                {' '}
                Get the Look{' '}
              </span>
              section by browsing curated looks in styles you love. For truly
              unique finds, you can browse our
              <span
                className="cursor-pointer primary-color"
                onClick={() =>
                  handleLinkOpen(routesByName.getTheLook.ambassadors.index)
                }
              >
                {' '}
                Ambassador Showcases
              </span>
              , featuring beautiful room images and Look Board ideas based on
              niche inspirations.
            </p>
            <p
              className={`${classes.paragraph} color-gray-6 font-italic pr-5 mb-2 text-sm`}
            >
              You can also
              <span
                className="cursor-pointer primary-color"
                onClick={() =>
                  handleLinkOpen(routesByName.requestTheLook.index)
                }
              >
                {' '}
                Request the Look{' '}
              </span>
              of your favorite images by pinning them online or uploading them
              from your computer. Your Request will be matched with
              <span
                className="cursor-pointer primary-color"
                onClick={() =>
                  handleLinkOpen(routesByName.getTheLook.ambassadors.index)
                }
              >
                {' '}
                Ambassadors{' '}
              </span>
              - real people with a passion and flair for decorating who will
              send you Look Board ideas.
            </p>
            <p
              className={`${classes.paragraph} color-gray-6 font-italic pr-5 mb-2 text-sm`}
            >
              Look Boards feature items from anywhere online to get the look of
              an image. While some Look Boards will showcase only items similar
              to the ones in your requested image, others will offer ways to get
              the look in different colors and styles. You can
              <span
                className="cursor-pointer primary-color"
                onClick={() =>
                  handleLinkOpen(routesByName.getTheLook.mixMatch.index)
                }
              >
                {' '}
                Mix & Match{' '}
              </span>
              any of the recommended items to create a new Look Board with your
              favorites!
            </p>
            <p
              className={`${classes.paragraph} color-gray-6 font-italic pr-5 mb-2 text-sm`}
            >
              Finally, you can
              <span
                className="cursor-pointer primary-color"
                onClick={() =>
                  handleLinkOpen(routesByName.curateTheLook.canvas)
                }
              >
                {' '}
                Curate the Look{' '}
              </span>
              yourself! Simply pin or upload your favorite image, or select one
              from our database. Then drag and drop vetted products from our
              database of home furnishings to create your own Look Board.
            </p>
            <p
              className={`${classes.paragraph} color-gray-6 font-italic pr-5 mb-2 text-sm`}
            >
              With access to hundreds of curated looks in popular styles,
              easy-to-use curation tools, and personal shopping assistance from
              our Ambassadors, getting the look you love for your home is now
              easier than ever!
            </p>
            <h2
              className={`${classes.paragraph} font-title text-uppercase mt-5`}
            >
              PIN THE LOOK MAIN SECTIONS:
            </h2>
            <div className={`${classes.items} d-flex flex-wrap`}>
              {aboutUsConfigFirst.map(
                ({ id, title, description, icon, route }) => (
                  <div key={id} className={classes.item}>
                    <h2 className={`${classes.subTitle} font-semi-bold mb-2`}>
                      {title}
                    </h2>
                    <p
                      className={`${classes.paragraph} color-gray-6 font-italic mb-3`}
                      /* eslint-disable-next-line react/no-danger */
                      dangerouslySetInnerHTML={{ __html: description }}
                    />
                    <IconButton
                      className={classes.icon}
                      component={Link}
                      to={route}
                    >
                      <SpriteIcon name={icon} size="lg" />
                    </IconButton>
                  </div>
                )
              )}
            </div>
            <h2 className={`${classes.paragraph} font-title text-uppercase`}>
              PIN THE LOOK OFFERS A BETTER WAY TO SHOP:
            </h2>
            <div className={`${classes.items} d-flex flex-wrap`}>
              {aboutUsConfigSecond.map(({ id, title, description, icon }) => (
                <div key={id} className={classes.item}>
                  <h2 className={`${classes.subTitle} font-semi-bold mb-2`}>
                    {title}
                  </h2>
                  <p
                    className={`${classes.paragraph} color-gray-6 font-italic mb-3`}
                    /* eslint-disable-next-line react/no-danger */
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                  <span className={`${classes.icon}`}>
                    <SpriteIcon name={icon} size="lg" />
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className={`${classes.rightColumn} col-5`}>
            <div className={classes.bannerBg} style={bannerBgStyle} />
            <div className={classes.bannerContent}>
              <img className="w-100" src={roomsImg} alt="" />
              <div className="d-flex justify-content-end">
                <div className="pl-5">
                  <div
                    className={`${classes.title} font-title text-uppercase mb-3`}
                    style={{ lineHeight: 1.5 }}
                  >
                    ‘’Pin the Look <br /> makes home <br /> decor shopping{' '}
                    <br /> a breeze!’’
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-7" />
          <h2 className="col-5 text-center py-5 font-title primary-color font-semi-bold">
            Let’s Decorate the World!
          </h2>
        </div>
      </div>
    </section>
  );
};

export default AboutContainer;
